import { connect } from 'react-redux'
import compose from 'recompose/compose'
import ListItem from '../../components/2d/elements_list/ListItem'
import { listItemSelected } from '../../actions/interactiveElementsListActions'
import { pausePositionalMediaPlayers } from '../../actions/positionalMediaActions'
import { setForceRotate } from '../../../players/panoplayer/actions/panoramaActions'
import { cartesianToCameraGeo } from '../../../utils/conversions'
import { lookupElement } from '../../methods/lookupElement'

const mapStateToProps = (state, { type, id, stopId }) => {
    const el = state.getIn(['interactiveElements', type, 'byId', String(id)]).toJS()
    const isMobile = state.getIn(['device', 'isDeviceMobile']) === true

    let mediaType = ''
    if (type === 'hotspots') {
        mediaType = lookupElement({ type: 'mediaItems', id: el.mediaItems[0], state }).get('item_type')
    }
    return {
        ...el,
        isVisited: checkIsVisited(state.getIn(['interactiveElements', 'meta', 'visited', 'byStop', String(stopId)]), {
            id,
            type,
        }),
        currentState: state.getIn(['interactiveElements', 'interactiveElementsListState']),
        elementType: type,
        mediaType,
        isMobile,
    }
}

const mapDispatchToProps = dispatch => ({
    handleListItemClickCallback: ({ id, elementType, lat, lon }) => {
        dispatch(listItemSelected({ id, elementType }))
        dispatch(setForceRotate({ coords: { lat, lon } }))
    },

    pausePositionalMediaPlayers: () => {
        dispatch(pausePositionalMediaPlayers())
    },
})

const checkIsVisited = (visited, { id, type }) => visited && visited.find(item => item.id === id && item.type === type)

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onClickListItem: () => {
        const {
            center: { x, y, z },
            id,
            elementType,
        } = stateProps
        const { lat, lon } = cartesianToCameraGeo({ x, y, z })

        dispatchProps.pausePositionalMediaPlayers()
        dispatchProps.handleListItemClickCallback({ id, elementType, lat, lon })
    },
})

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    )
)(ListItem)
